import { postRequest, getRequest, putRequest, formDataPutRequest, deleteRequest, formDataPostRequest } from "../system/server-call";
// eslint-disable-next-line import/no-cycle
import responseHandler from "../system/server-response-handler";
import {
  setItemToStorage,
  removeItemFromStorage,
  clearStorage,
  encryptObject,
} from "../system";

/**
 *The Auth Service
 *
 *This is used for getting data from server and handling the business logic on that data
 */
//Logging out the user from the app and removing its information from browser

//Handling the Login response, if user is authenticated then saving
//the jwt token in the local storage
function handleLoginResponse(appPayload) {
  const ciphertext = encryptObject({ ...appPayload });
  setItemToStorage(process.env.REACT_APP_PAYLOAD, ciphertext);
}

//Authenticating the user from server
function login(userData) {
  const appPayload = {};
  return postRequest("auth/login", userData, false, false)
    .then((response) => {
      return responseHandler.handleServerResponse(response);
    })
    .catch((error) => {
      return responseHandler.handleServerResponse(error?.response || { status: 500, data: { message: "Server connection failed." } });
    });
}

function logout() {
  return postRequest("auth/logout")
    .then((response) => {
      return responseHandler.handleServerResponse(response);
    })
    .catch((error) => {
      return responseHandler.handleServerResponse(error?.response || { status: 500, data: { message: "Server connection failed." } });
    });
}

function changePassword(data) {
  return formDataPostRequest("users/change-password", data,true)
    .then((response) => {
      return responseHandler.handleServerResponse(response);
    })
    .catch((error) => {
      return responseHandler.handleServerResponse(error?.response || { status: 500, data: { message: "Server connection failed." } });
    });
}

async function getAll() {
  return getRequest(
    `users`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getById(id) {
  return getRequest(
    `get/user/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getPermissions(id) {
  return getRequest(
    `get/permissions/list`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}


async function deleteById(id) {
    return putRequest(
    `users/activation/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function create(data) {
    return formDataPostRequest(
    `users`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function update(data, id) {
    return formDataPostRequest(
    `users/${id}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deleteUserPermanentById(id) {
    return deleteRequest(
    `delete/user/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllNotifications() {
  return getRequest(
    `notifications`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getNotificationById(id) {
  return getRequest(
    `get/notification/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function updateNotification(data) {
    return postRequest(
    `notifications/${data.id}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

//Exporting functions for other files
export const userService = {
  login,
  logout,
  handleLoginResponse,
  getAll,
  getById,
  deleteById,
  create,
  update,
  deleteUserPermanentById,
  getPermissions,
  getAllNotifications,
  getNotificationById,
  updateNotification,
  changePassword
};
